import type { Manejo } from "./dominio.js";
import { sinTildes } from "./texto.js";

/**
 * Reglas del control de registros que comparten el formulario y la API.
 */

/** Si el manejo incluye papel, hay que decir dónde se archiva. */
export function tieneCopiaFisica(manejo: Manejo | string): boolean {
  return manejo === "fisico" || manejo === "fisico_y_digital";
}

/** Lo que falta para poder enviar un registro a revisión: la ubicación de la copia física. */
export function faltaUbicacionFisica(
  manejo: Manejo | string,
  ubicacion: string | null | undefined,
): boolean {
  return tieneCopiaFisica(manejo) && !ubicacion?.trim();
}

/** Dónde está la copia digital: siempre GestionDOC. Se muestra, no se guarda. */
export function ubicacionDigital(codigo: string): string {
  return `GestionDOC · ${codigo}`;
}

const VACIAS = new Set([
  "a",
  "al",
  "con",
  "de",
  "del",
  "el",
  "en",
  "la",
  "las",
  "los",
  "para",
  "por",
  "un",
  "una",
  "y",
]);

/**
 * Indexación sugerida: fecha y hasta tres palabras del nombre, sin "Registro de" ni palabras
 * vacías ni tildes. "Registro de asistencia a capacitaciones" → "AAAA-MM-DD_Asistencia_capacitaciones".
 */
export function indexacionPorDefecto(nombre: string): string {
  const palabras = sinTildes(nombre)
    .replace(/[^A-Za-z0-9ñÑ\s]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p.toLowerCase());
  if (palabras[0] === "registro" || palabras[0] === "formato") palabras.shift();
  const utiles = palabras.filter((p) => !VACIAS.has(p)).slice(0, 3);
  if (utiles.length === 0) return "AAAA-MM-DD";
  const [primera = "", ...resto] = utiles;
  return `AAAA-MM-DD_${[primera.charAt(0).toUpperCase() + primera.slice(1), ...resto].join("_")}`;
}
